import React from 'react';
import type { CampaignCard as CampaignCardStyles } from '../css/CampaignCard.modules';
import JoinInButton from '../../../shared/JoinIn/JoinInButton';

interface CampaignCardButtonProps {
  campaignId: string;
  showButton: boolean;
  campaignCardStyles: CampaignCardStyles;
}

const CampaignCardButton: React.FC<CampaignCardButtonProps> = ({
  campaignId,
  showButton
}) => (
  showButton ? <JoinInButton campaignId={campaignId} /> : null
);

export default CampaignCardButton;
